package br.com.vvrefeicoes.portal.feature.notifications

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.FilterChip
import androidx.compose.material3.FilterChipDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.ParagraphStyle
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextDecoration
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppPagination
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.AppTooltipText
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.MultiSelectField
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.components.SelectOption
import br.com.vvrefeicoes.portal.core.ui.components.SuccessDialog
import br.com.vvrefeicoes.portal.core.ui.layout.AppHorizontalScrollbar
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.PeriodMode
import br.com.vvrefeicoes.portal.core.util.formatIsoDateTime
import br.com.vvrefeicoes.portal.core.util.image.isImageUploadSupported
import br.com.vvrefeicoes.portal.core.util.image.pickImageFile
import br.com.vvrefeicoes.portal.domain.model.Announcement
import br.com.vvrefeicoes.portal.domain.model.AnnouncementAudience
import br.com.vvrefeicoes.portal.domain.model.NotificationPriority
import br.com.vvrefeicoes.portal.feature.operacional.PeriodSelector
import com.composables.icons.lucide.ArrowLeft
import com.composables.icons.lucide.Bold
import com.composables.icons.lucide.Code
import com.composables.icons.lucide.EllipsisVertical
import com.composables.icons.lucide.Eye
import com.composables.icons.lucide.Heading1
import com.composables.icons.lucide.Heading2
import com.composables.icons.lucide.Heading3
import com.composables.icons.lucide.Image
import com.composables.icons.lucide.Info
import com.composables.icons.lucide.Italic
import com.composables.icons.lucide.Link
import com.composables.icons.lucide.List
import com.composables.icons.lucide.ListIndentDecrease
import com.composables.icons.lucide.ListIndentIncrease
import com.composables.icons.lucide.ListOrdered
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Pencil
import com.composables.icons.lucide.Plus
import com.composables.icons.lucide.Redo2
import com.composables.icons.lucide.RemoveFormatting
import com.composables.icons.lucide.Search
import com.composables.icons.lucide.Strikethrough
import com.composables.icons.lucide.TextAlignCenter
import com.composables.icons.lucide.TextAlignEnd
import com.composables.icons.lucide.TextAlignJustify
import com.composables.icons.lucide.TextAlignStart
import com.composables.icons.lucide.Trash2
import com.composables.icons.lucide.Underline
import com.composables.icons.lucide.Undo2
import com.composables.icons.lucide.Upload
import com.mohamedrejeb.richeditor.model.HeadingStyle
import com.mohamedrejeb.richeditor.model.RichTextState
import com.mohamedrejeb.richeditor.model.rememberRichTextState
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditor
import com.mohamedrejeb.richeditor.ui.material3.RichTextEditorDefaults
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.announcements_action_view
import portalvv.shared.generated.resources.announcements_audience_all
import portalvv.shared.generated.resources.announcements_audience_role
import portalvv.shared.generated.resources.announcements_audience_unit
import portalvv.shared.generated.resources.announcements_audience_user
import portalvv.shared.generated.resources.announcements_col_actions
import portalvv.shared.generated.resources.announcements_col_audience
import portalvv.shared.generated.resources.announcements_col_date
import portalvv.shared.generated.resources.announcements_col_priority
import portalvv.shared.generated.resources.announcements_col_status
import portalvv.shared.generated.resources.announcements_col_title
import portalvv.shared.generated.resources.announcements_delete_message
import portalvv.shared.generated.resources.announcements_delete_title
import portalvv.shared.generated.resources.announcements_detail_edited_at
import portalvv.shared.generated.resources.announcements_detail_published_at
import portalvv.shared.generated.resources.announcements_edit_title
import portalvv.shared.generated.resources.announcements_email_hint
import portalvv.shared.generated.resources.announcements_empty_value
import portalvv.shared.generated.resources.announcements_field_content
import portalvv.shared.generated.resources.announcements_field_image
import portalvv.shared.generated.resources.announcements_field_image_plain
import portalvv.shared.generated.resources.announcements_form_title
import portalvv.shared.generated.resources.announcements_format_align_center
import portalvv.shared.generated.resources.announcements_format_align_end
import portalvv.shared.generated.resources.announcements_format_align_justify
import portalvv.shared.generated.resources.announcements_format_align_start
import portalvv.shared.generated.resources.announcements_format_bold
import portalvv.shared.generated.resources.announcements_format_bullet
import portalvv.shared.generated.resources.announcements_format_clear
import portalvv.shared.generated.resources.announcements_format_code
import portalvv.shared.generated.resources.announcements_format_heading1
import portalvv.shared.generated.resources.announcements_format_heading2
import portalvv.shared.generated.resources.announcements_format_heading3
import portalvv.shared.generated.resources.announcements_format_indent_decrease
import portalvv.shared.generated.resources.announcements_format_indent_increase
import portalvv.shared.generated.resources.announcements_format_italic
import portalvv.shared.generated.resources.announcements_format_link
import portalvv.shared.generated.resources.announcements_format_ordered
import portalvv.shared.generated.resources.announcements_format_redo
import portalvv.shared.generated.resources.announcements_format_strike
import portalvv.shared.generated.resources.announcements_format_underline
import portalvv.shared.generated.resources.announcements_format_undo
import portalvv.shared.generated.resources.announcements_image_remove
import portalvv.shared.generated.resources.announcements_image_resources
import portalvv.shared.generated.resources.announcements_image_send
import portalvv.shared.generated.resources.announcements_image_upload
import portalvv.shared.generated.resources.announcements_image_upload_hint
import portalvv.shared.generated.resources.announcements_image_upload_unsupported
import portalvv.shared.generated.resources.announcements_link_confirm
import portalvv.shared.generated.resources.announcements_link_url
import portalvv.shared.generated.resources.announcements_more_items
import portalvv.shared.generated.resources.announcements_new_title
import portalvv.shared.generated.resources.announcements_no_options
import portalvv.shared.generated.resources.announcements_priority_high_desc
import portalvv.shared.generated.resources.announcements_priority_info_hint
import portalvv.shared.generated.resources.announcements_priority_info_title
import portalvv.shared.generated.resources.announcements_priority_low_desc
import portalvv.shared.generated.resources.announcements_priority_medium_desc
import portalvv.shared.generated.resources.announcements_publish
import portalvv.shared.generated.resources.announcements_publish_confirm
import portalvv.shared.generated.resources.announcements_publish_success
import portalvv.shared.generated.resources.announcements_publish_title
import portalvv.shared.generated.resources.announcements_retry
import portalvv.shared.generated.resources.announcements_save_draft
import portalvv.shared.generated.resources.announcements_search
import portalvv.shared.generated.resources.announcements_search_placeholder
import portalvv.shared.generated.resources.announcements_view_preview
import portalvv.shared.generated.resources.back
import portalvv.shared.generated.resources.guides_insert_image
import portalvv.shared.generated.resources.notifications_action_delete
import portalvv.shared.generated.resources.notifications_action_edit
import portalvv.shared.generated.resources.notifications_cancel
import portalvv.shared.generated.resources.notifications_field_priority
import portalvv.shared.generated.resources.notifications_field_title
import portalvv.shared.generated.resources.notifications_management_empty
import portalvv.shared.generated.resources.notifications_management_new
import portalvv.shared.generated.resources.notifications_management_title
import portalvv.shared.generated.resources.notifications_priority_high
import portalvv.shared.generated.resources.notifications_priority_low
import portalvv.shared.generated.resources.notifications_priority_medium
import portalvv.shared.generated.resources.notifications_status_active
import portalvv.shared.generated.resources.notifications_status_inactive
import portalvv.shared.generated.resources.notifications_target_all

private val W_DATE = 1.0f
private val W_TITLE = 3.1f
private val W_PRIORITY = 1.0f
private val W_AUDIENCE = 2.3f
private val W_STATUS = 1.1f
private val W_ACTIONS = 0.4f
private val MIN_TABLE_WIDTH = 1040.dp

@Composable
fun AnnouncementsManagementScreen() {
    val controller = rememberAnnouncementsManagementController()
    LaunchedEffect(controller) { controller.init() }

    AppScrollColumn(
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(AppSpacing.space24),
        verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        footer = { AppFooter() },
    ) {
        if (controller.formOpen) {
            AnnouncementForm(controller)
        } else {
            AnnouncementsList(controller)
        }
    }

    controller.viewing?.let { viewing ->
        AnnouncementDetailDialog(
            announcement = viewing,
            audience = audienceText(controller, viewing),
            onDismiss = controller::closeView,
        )
    }

    if (controller.showPublishSuccess) {
        SuccessDialog(
            title = stringResource(Res.string.announcements_publish_success),
            onDismiss = controller::dismissPublishSuccess,
        )
    }

    controller.deleteTarget?.let { target ->
        ConfirmDialog(
            title = stringResource(Res.string.announcements_delete_title),
            message = stringResource(Res.string.announcements_delete_message, target.title),
            confirmLabel = stringResource(Res.string.notifications_action_delete),
            onConfirm = controller::confirmDelete,
            onDismiss = controller::dismissDelete,
        )
    }
}

@Composable
private fun ConfirmDialog(
    title: String,
    message: String,
    confirmLabel: String,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    AppModalCard(title = title, onDismiss = onDismiss) {
        Text(
            text = message,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.notifications_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
            AppButton(
                text = confirmLabel,
                onClick = onConfirm,
                variant = PortalButtonVariant.Filled,
            )
        }
    }
}

@Composable
private fun ColumnScope.AnnouncementsList(controller: AnnouncementsManagementController) {
    Text(
        text = stringResource(Res.string.notifications_management_title),
        style = MaterialTheme.typography.headlineMedium,
    )

    controller.errorMessage?.let { message ->
        ErrorSurface(message = message, onRetry = controller::retry)
    }

    AnnouncementsFilters(controller)

    when {
        controller.loading -> LoadingBox()
        controller.announcements.isEmpty() -> EmptyState(message = stringResource(Res.string.notifications_management_empty))
        else -> {
            AnnouncementTable(controller)
            AppPagination(
                page = controller.page,
                pageCount = controller.pageCount,
                onPageChange = controller::goToPage,
                modifier = Modifier.align(Alignment.End),
            )
        }
    }
}

@Composable
private fun ErrorSurface(
    message: String,
    onRetry: () -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        color = MaterialTheme.colorScheme.errorContainer,
        shape = AppShapes.medium,
    ) {
        Row(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Text(
                text = message,
                color = MaterialTheme.colorScheme.onErrorContainer,
                modifier = Modifier.weight(1f),
            )
            AppButton(
                text = stringResource(Res.string.announcements_retry),
                onClick = onRetry,
                variant = PortalButtonVariant.Outlined,
            )
        }
    }
}

@Composable
private fun AnnouncementsFilters(controller: AnnouncementsManagementController) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            PeriodSelector(
                selection = controller.period,
                onMode = { mode -> controller.applyPeriod(controller.period.copy(mode = mode)) },
                onMonth = { month -> controller.applyPeriod(controller.period.copy(mode = PeriodMode.MONTH, month = month)) },
                onYear = { year -> controller.applyPeriod(controller.period.copy(mode = PeriodMode.YEAR, year = year)) },
                onCustom = { start, end -> controller.applyPeriod(controller.period.copy(mode = PeriodMode.CUSTOM, start = start, end = end)) },
                bordered = false,
            )
            AppTextField(
                value = controller.query,
                onValueChange = controller::updateQuery,
                placeholder = stringResource(Res.string.announcements_search_placeholder),
                leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
                modifier = Modifier.fillMaxWidth(),
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                AppButton(
                    text = stringResource(Res.string.notifications_management_new),
                    onClick = controller::openCreate,
                    leadingIcon = Lucide.Plus,
                )
            }
        }
    }
}

@Composable
private fun LoadingBox() {
    Box(
        modifier = Modifier.fillMaxWidth().height(240.dp),
        contentAlignment = Alignment.Center,
    ) {
        CircularProgressIndicator()
    }
}

@Composable
private fun AnnouncementTable(controller: AnnouncementsManagementController) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
    ) {
        BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
            val scrollState = rememberScrollState()
            val tableWidth = maxOf(maxWidth, MIN_TABLE_WIDTH)
            Column {
                Box(modifier = Modifier.fillMaxWidth().horizontalScroll(scrollState)) {
                    Column(modifier = Modifier.width(tableWidth)) {
                        AnnouncementHeaderRow()
                        HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                        controller.announcements.forEachIndexed { index, announcement ->
                            AnnouncementTableRow(
                                announcement = announcement,
                                audience = audienceText(controller, announcement),
                                onView = { controller.openView(announcement) },
                                onEdit = { controller.openEdit(announcement) },
                                onDelete = { controller.requestDelete(announcement) },
                            )
                            if (index < controller.announcements.lastIndex) {
                                HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                            }
                        }
                    }
                }
                AppHorizontalScrollbar(
                    state = scrollState,
                    modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space8),
                )
            }
        }
    }
}

@Composable
private fun AnnouncementHeaderRow() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        HeaderCell(stringResource(Res.string.announcements_col_date), W_DATE, TextAlign.Start)
        HeaderCell(stringResource(Res.string.announcements_col_title), W_TITLE, TextAlign.Start)
        HeaderCell(stringResource(Res.string.announcements_col_audience), W_AUDIENCE, TextAlign.Start)
        HeaderCell(stringResource(Res.string.announcements_col_priority), W_PRIORITY, TextAlign.Start)
        HeaderCell(stringResource(Res.string.announcements_col_status), W_STATUS, TextAlign.Start)
        HeaderCell(stringResource(Res.string.announcements_col_actions), W_ACTIONS, TextAlign.Start)
    }
}

@Composable
private fun AnnouncementTableRow(
    announcement: Announcement,
    audience: String,
    onView: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
    ) {
        BodyCell(
            (if (announcement.active) announcement.publishedAt else announcement.updatedAt)
                ?.let { formatIsoDateTime(it) }
                .orEmpty()
                .ifEmpty { stringResource(Res.string.announcements_empty_value) },
            W_DATE,
        )
        BodyCell(announcement.title, W_TITLE)
        AppTooltipText(
            text = audience,
            tooltipText = audience,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurface,
            modifier = Modifier.weight(W_AUDIENCE),
        )
        Row(modifier = Modifier.weight(W_PRIORITY)) {
            PriorityChip(announcement.priority)
        }
        Row(modifier = Modifier.weight(W_STATUS)) {
            StatusBadge(announcement.active)
        }
        Box(modifier = Modifier.weight(W_ACTIONS)) {
            AnnouncementActionsMenu(
                draft = !announcement.active,
                onView = onView,
                onEdit = onEdit,
                onDelete = onDelete,
            )
        }
    }
}

@Composable
private fun AnnouncementActionsMenu(
    draft: Boolean,
    onView: () -> Unit,
    onEdit: () -> Unit,
    onDelete: () -> Unit,
) {
    var expanded by remember { mutableStateOf(false) }
    Box {
        IconButton(
            onClick = { expanded = true },
            modifier = Modifier.size(24.dp),
        ) {
            Icon(
                imageVector = Lucide.EllipsisVertical,
                contentDescription = stringResource(Res.string.announcements_col_actions),
                tint = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
            DropdownMenuItem(
                text = { Text(stringResource(Res.string.announcements_action_view)) },
                leadingIcon = { Icon(Lucide.Eye, contentDescription = null) },
                onClick = {
                    expanded = false
                    onView()
                },
            )
            if (draft) {
                DropdownMenuItem(
                    text = { Text(stringResource(Res.string.notifications_action_edit)) },
                    leadingIcon = { Icon(Lucide.Pencil, contentDescription = null) },
                    onClick = {
                        expanded = false
                        onEdit()
                    },
                )
                DropdownMenuItem(
                    text = { Text(stringResource(Res.string.notifications_action_delete)) },
                    leadingIcon = { Icon(Lucide.Trash2, contentDescription = null) },
                    onClick = {
                        expanded = false
                        onDelete()
                    },
                )
            }
        }
    }
}

@Composable
private fun RowScope.HeaderCell(
    text: String,
    weight: Float,
    align: TextAlign,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.labelMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        textAlign = align,
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun RowScope.BodyCell(
    text: String,
    weight: Float,
    align: TextAlign = TextAlign.Start,
) {
    Text(
        text = text,
        style = MaterialTheme.typography.bodyMedium,
        maxLines = 1,
        overflow = TextOverflow.Ellipsis,
        textAlign = align,
        modifier = Modifier.weight(weight),
    )
}

@Composable
private fun StatusBadge(active: Boolean) {
    Surface(
        shape = AppShapes.small,
        color = if (active) AppPalette.Info100 else MaterialTheme.colorScheme.surfaceVariant,
        contentColor = if (active) AppPalette.Info900 else MaterialTheme.colorScheme.onSurfaceVariant,
    ) {
        Text(
            text = stringResource(if (active) Res.string.notifications_status_active else Res.string.notifications_status_inactive),
            style = MaterialTheme.typography.labelSmall,
            modifier = Modifier.padding(horizontal = AppSpacing.space8, vertical = 2.dp),
        )
    }
}

@Composable
private fun audienceText(
    controller: AnnouncementsManagementController,
    announcement: Announcement,
): String {
    if (announcement.targets.isEmpty()) return stringResource(Res.string.notifications_target_all)
    val names = controller.audienceNames(announcement)
    return if (names.isEmpty()) announcement.targets.size.toString() else names.joinToString(", ")
}

@Composable
private fun AnnouncementDetailDialog(
    announcement: Announcement,
    audience: String,
    onDismiss: () -> Unit,
) {
    AppModalCard(title = stringResource(Res.string.announcements_form_title), onDismiss = onDismiss) {
        StatusBadge(announcement.active)
        DetailSection(
            title =
                stringResource(
                    if (announcement.active) Res.string.announcements_detail_published_at else Res.string.announcements_detail_edited_at,
                ),
            value =
                (if (announcement.active) announcement.publishedAt else announcement.updatedAt)
                    ?.let { formatIsoDateTime(it) }
                    .orEmpty()
                    .ifEmpty { stringResource(Res.string.announcements_empty_value) },
            bordered = false,
        )
        DetailSection(title = stringResource(Res.string.announcements_col_title), value = announcement.title, bordered = false)
        Section(title = stringResource(Res.string.announcements_field_image_plain), bordered = false) {
            if (announcement.imageUrl.isNullOrBlank()) {
                Text(
                    text = stringResource(Res.string.announcements_empty_value),
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            } else {
                AnnouncementImage(source = announcement.imageUrl, modifier = Modifier.fillMaxWidth().heightIn(max = 320.dp))
            }
        }
        Section(title = stringResource(Res.string.announcements_field_content), bordered = false) {
            RichBody(html = announcement.body, modifier = Modifier.fillMaxWidth())
        }
        DetailSection(title = stringResource(Res.string.announcements_col_audience), value = audience, bordered = false)
        Section(title = stringResource(Res.string.notifications_field_priority), bordered = false) {
            PriorityChip(announcement.priority)
        }
    }
}

@Composable
private fun DetailSection(
    title: String,
    value: String,
    bordered: Boolean = true,
) {
    Section(title = title, bordered = bordered) {
        Text(text = value, style = MaterialTheme.typography.bodyMedium)
    }
}

@Composable
internal fun Section(
    title: String,
    trailing: (@Composable () -> Unit)? = null,
    bordered: Boolean = true,
    content: @Composable ColumnScope.() -> Unit,
) {
    Surface(
        modifier = Modifier.fillMaxWidth(),
        shape = AppShapes.large,
        color = MaterialTheme.colorScheme.surface,
        border = if (bordered) BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant) else null,
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space16),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        ) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                Text(text = title, style = MaterialTheme.typography.titleMedium)
                trailing?.invoke()
            }
            content()
        }
    }
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun ColumnScope.AnnouncementForm(controller: AnnouncementsManagementController) {
    val scope = rememberCoroutineScope()
    val richState = rememberRichTextState()
    var showPriorityInfo by remember { mutableStateOf(false) }
    var preview by remember { mutableStateOf<AnnouncementPreviewSnapshot?>(null) }
    var pendingPublish by remember { mutableStateOf<AnnouncementPreviewSnapshot?>(null) }
    LaunchedEffect(controller.editingId) { runCatching { richState.setHtml(controller.formBody) } }

    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
    ) {
        Text(
            text = stringResource(if (controller.editingId == null) Res.string.announcements_new_title else Res.string.announcements_edit_title),
            style = MaterialTheme.typography.headlineMedium,
        )
        AppButton(
            text = stringResource(Res.string.back),
            onClick = controller::dismissForm,
            variant = PortalButtonVariant.Text,
            leadingIcon = Lucide.ArrowLeft,
        )
    }

    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
    ) {
        AppButton(
            text = stringResource(Res.string.announcements_save_draft),
            onClick = { controller.submit(richState.toHtml(), publish = false) },
            enabled = controller.canSubmit,
            variant = PortalButtonVariant.Outlined,
        )
        AppButton(
            text = stringResource(Res.string.announcements_publish),
            onClick = {
                val html = richState.toHtml()
                if (controller.validate(html)) {
                    pendingPublish = AnnouncementPreviewSnapshot(controller.formTitle, controller.formImageUrl.ifBlank { null }, html)
                }
            },
            enabled = controller.canSubmit,
            variant = PortalButtonVariant.Accent,
        )
    }

    controller.errorMessage?.let { message ->
        ErrorSurface(message = message, onRetry = controller::retry)
    }

    Section(title = stringResource(Res.string.announcements_col_title)) {
        AppTextField(
            value = controller.formTitle,
            onValueChange = { controller.formTitle = it },
            placeholder = stringResource(Res.string.notifications_field_title),
            modifier = Modifier.fillMaxWidth(),
        )
    }

    Section(title = stringResource(Res.string.announcements_field_image)) {
        ImageField(controller = controller, scope = scope)
    }

    Section(title = stringResource(Res.string.announcements_field_content)) {
        RichTextToolbar(state = richState)
        Surface(
            shape = AppShapes.medium,
            color = Color.White,
            border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
        ) {
            RichTextEditor(
                state = richState,
                colors = RichTextEditorDefaults.richTextEditorColors(containerColor = Color.White),
                modifier = Modifier.fillMaxWidth().heightIn(min = 200.dp).padding(AppSpacing.space12),
            )
        }
    }

    Section(title = stringResource(Res.string.announcements_col_audience)) {
        AudienceField(controller = controller)
    }

    Section(
        title = stringResource(Res.string.notifications_field_priority),
        trailing = { PriorityInfoButton(onClick = { showPriorityInfo = true }) },
    ) {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            NotificationPriority.entries.forEach { priority ->
                val color = priorityColor(priority)
                FilterChip(
                    selected = controller.formPriority == priority,
                    onClick = { controller.formPriority = priority },
                    label = { Text(priorityLabel(priority)) },
                    colors =
                        FilterChipDefaults.filterChipColors(
                            selectedContainerColor = color.copy(alpha = 0.16f),
                            selectedLabelColor = color,
                        ),
                )
            }
        }
        Text(
            text = stringResource(Res.string.announcements_email_hint),
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }

    if (showPriorityInfo) {
        PriorityInfoDialog(onDismiss = { showPriorityInfo = false })
    }

    pendingPublish?.let { snapshot ->
        PublishConfirmDialog(
            message = stringResource(Res.string.announcements_publish_confirm, snapshot.title),
            onPreview = {
                preview = snapshot
                pendingPublish = null
            },
            onConfirm = {
                controller.submit(snapshot.bodyHtml, publish = true)
                pendingPublish = null
            },
            onDismiss = { pendingPublish = null },
        )
    }

    preview?.let { snapshot ->
        AnnouncementModal(
            title = snapshot.title,
            imageUrl = snapshot.imageUrl,
            bodyHtml = snapshot.bodyHtml,
            onDismiss = { preview = null },
            actions = {},
        )
    }
}

@Composable
private fun PublishConfirmDialog(
    message: String,
    onPreview: () -> Unit,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit,
) {
    AppModalCard(title = stringResource(Res.string.announcements_publish_title), onDismiss = onDismiss) {
        Text(
            text = message,
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
        ) {
            AppButton(
                text = stringResource(Res.string.announcements_view_preview),
                onClick = onPreview,
                variant = PortalButtonVariant.Outlined,
            )
            AppButton(
                text = stringResource(Res.string.announcements_publish),
                onClick = onConfirm,
                variant = PortalButtonVariant.Accent,
            )
        }
    }
}

private data class AnnouncementPreviewSnapshot(
    val title: String,
    val imageUrl: String?,
    val bodyHtml: String,
)

@Composable
private fun ImageField(
    controller: AnnouncementsManagementController,
    scope: kotlinx.coroutines.CoroutineScope,
) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            FilterChip(
                selected = controller.imageMode == AnnouncementImageMode.UPLOAD,
                onClick = { controller.selectImageMode(AnnouncementImageMode.UPLOAD) },
                label = { Text(stringResource(Res.string.announcements_image_upload)) },
            )
            FilterChip(
                selected = controller.imageMode == AnnouncementImageMode.RESOURCES,
                onClick = { controller.selectImageMode(AnnouncementImageMode.RESOURCES) },
                label = { Text(stringResource(Res.string.announcements_image_resources)) },
            )
        }

        if (controller.formImageUrl.isNotBlank()) {
            AnnouncementImage(source = controller.formImageUrl, modifier = Modifier.fillMaxWidth().heightIn(max = 200.dp))
        }

        when (controller.imageMode) {
            AnnouncementImageMode.UPLOAD -> {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    if (isImageUploadSupported()) {
                        AppButton(
                            text = stringResource(Res.string.announcements_image_send),
                            onClick = { scope.launch { pickImageFile()?.let { controller.uploadImage(it.bytes, it.contentType) } } },
                            enabled = !controller.uploading,
                            variant = PortalButtonVariant.Filled,
                            leadingIcon = Lucide.Upload,
                        )
                    }
                    if (controller.formImageUrl.isNotBlank()) {
                        RemoveImageButton(onClick = controller::clearImage)
                    }
                }
                if (isImageUploadSupported()) {
                    Text(
                        text = stringResource(Res.string.announcements_image_upload_hint),
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                if (!isImageUploadSupported()) {
                    Text(
                        text = stringResource(Res.string.announcements_image_upload_unsupported),
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                    )
                }
                if (controller.uploading) {
                    CircularProgressIndicator(modifier = Modifier.size(20.dp))
                }
            }

            AnnouncementImageMode.RESOURCES -> {
                val selectedKey = controller.formImageUrl.removePrefix("resource:").takeIf { controller.formImageUrl.startsWith("resource:") }
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                    verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                ) {
                    bundledImageKeys().forEach { key ->
                        val selected = key == selectedKey
                        Surface(
                            shape = AppShapes.medium,
                            border =
                                BorderStroke(
                                    if (selected) 2.dp else 1.dp,
                                    if (selected) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.outlineVariant,
                                ),
                            modifier = Modifier.size(72.dp).clickable { controller.setImageResource(key) },
                        ) {
                            BundledImagePreview(key = key, modifier = Modifier.fillMaxSize().padding(4.dp))
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun RemoveImageButton(onClick: () -> Unit) {
    AppButton(
        text = stringResource(Res.string.announcements_image_remove),
        onClick = onClick,
        variant = PortalButtonVariant.Outlined,
        leadingIcon = Lucide.Trash2,
    )
}

@Composable
private fun AudienceField(controller: AnnouncementsManagementController) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
        FlowRow(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
            FilterChip(
                selected = controller.audienceMode == null,
                onClick = { controller.selectAudience(null) },
                label = { Text(stringResource(Res.string.announcements_audience_all)) },
            )
            AnnouncementAudience.entries.forEach { audience ->
                FilterChip(
                    selected = controller.audienceMode == audience,
                    onClick = { controller.selectAudience(audience) },
                    label = { Text(audienceLabel(audience)) },
                )
            }
        }

        val search = stringResource(Res.string.announcements_search)
        val empty = stringResource(Res.string.announcements_no_options)
        val moreItems: @Composable (Int) -> String = { count -> stringResource(Res.string.announcements_more_items, count) }
        when (controller.audienceMode) {
            null -> Unit
            AnnouncementAudience.ROLE ->
                MultiSelectField(
                    options = controller.profiles.map { SelectOption(it.id, it.name) },
                    selectedIds = controller.selectedRoles,
                    onToggle = controller::toggleRole,
                    searchPlaceholder = search,
                    emptyLabel = empty,
                    moreItemsLabel = moreItems,
                )
            AnnouncementAudience.UNIT ->
                MultiSelectField(
                    options = controller.companies.filterNot { it.inactive }.map { SelectOption(it.id, it.name) },
                    selectedIds = controller.selectedUnits,
                    onToggle = controller::toggleUnit,
                    searchPlaceholder = search,
                    emptyLabel = empty,
                    moreItemsLabel = moreItems,
                )
            AnnouncementAudience.USER ->
                MultiSelectField(
                    options = controller.users.map { SelectOption(it.id, it.name) },
                    selectedIds = controller.selectedUsers,
                    onToggle = controller::toggleUser,
                    searchPlaceholder = search,
                    emptyLabel = empty,
                    moreItemsLabel = moreItems,
                )
        }
    }
}

@Composable
internal fun RichTextToolbar(
    state: RichTextState,
    onInsertImage: (() -> Unit)? = null,
    uploadingImage: Boolean = false,
) {
    var linkDialog by remember { mutableStateOf(false) }
    var linkSelection by remember { mutableStateOf<TextRange?>(null) }
    val focusManager = LocalFocusManager.current

    Surface(shape = AppShapes.medium, color = MaterialTheme.colorScheme.surfaceVariant, modifier = Modifier.fillMaxWidth()) {
        FlowRow(
            modifier = Modifier.fillMaxWidth().padding(AppSpacing.space4),
            horizontalArrangement = Arrangement.spacedBy(2.dp),
            verticalArrangement = Arrangement.spacedBy(2.dp),
        ) {
            RichToolbarButton(Lucide.Undo2, stringResource(Res.string.announcements_format_undo), enabled = state.history.canUndo) { state.history.undo() }
            RichToolbarButton(Lucide.Redo2, stringResource(Res.string.announcements_format_redo), enabled = state.history.canRedo) { state.history.redo() }
            RichToolbarDivider()
            RichToolbarButton(Lucide.Bold, stringResource(Res.string.announcements_format_bold), active = state.currentSpanStyle.fontWeight == FontWeight.Bold) {
                state.toggleSpanStyle(SpanStyle(fontWeight = FontWeight.Bold))
            }
            RichToolbarButton(Lucide.Italic, stringResource(Res.string.announcements_format_italic), active = state.currentSpanStyle.fontStyle == FontStyle.Italic) {
                state.toggleSpanStyle(SpanStyle(fontStyle = FontStyle.Italic))
            }
            RichToolbarButton(Lucide.Underline, stringResource(Res.string.announcements_format_underline), active = state.currentSpanStyle.textDecoration == TextDecoration.Underline) {
                state.toggleSpanStyle(SpanStyle(textDecoration = TextDecoration.Underline))
            }
            RichToolbarButton(Lucide.Strikethrough, stringResource(Res.string.announcements_format_strike), active = state.currentSpanStyle.textDecoration == TextDecoration.LineThrough) {
                state.toggleSpanStyle(SpanStyle(textDecoration = TextDecoration.LineThrough))
            }
            RichToolbarDivider()
            HeadingButton(state, HeadingStyle.H1, Lucide.Heading1, stringResource(Res.string.announcements_format_heading1))
            HeadingButton(state, HeadingStyle.H2, Lucide.Heading2, stringResource(Res.string.announcements_format_heading2))
            HeadingButton(state, HeadingStyle.H3, Lucide.Heading3, stringResource(Res.string.announcements_format_heading3))
            RichToolbarDivider()
            RichToolbarButton(Lucide.List, stringResource(Res.string.announcements_format_bullet), active = state.isUnorderedList) { state.toggleUnorderedList() }
            RichToolbarButton(Lucide.ListOrdered, stringResource(Res.string.announcements_format_ordered), active = state.isOrderedList) { state.toggleOrderedList() }
            RichToolbarButton(Lucide.ListIndentDecrease, stringResource(Res.string.announcements_format_indent_decrease)) { state.decreaseListLevel() }
            RichToolbarButton(Lucide.ListIndentIncrease, stringResource(Res.string.announcements_format_indent_increase)) { state.increaseListLevel() }
            RichToolbarDivider()
            RichToolbarButton(Lucide.Code, stringResource(Res.string.announcements_format_code), active = state.isCodeSpan) { state.toggleCodeSpan() }
            RichToolbarButton(Lucide.Link, stringResource(Res.string.announcements_format_link), active = state.isLink) {
                if (state.isLink) {
                    state.removeLink()
                } else {
                    linkSelection = state.selection
                    focusManager.clearFocus()
                    linkDialog = true
                }
            }
            onInsertImage?.let { insertImage ->
                RichToolbarButton(
                    icon = Lucide.Image,
                    contentDescription = stringResource(Res.string.guides_insert_image),
                    enabled = !uploadingImage,
                    onClick = insertImage,
                )
            }
            RichToolbarDivider()
            AlignButton(state, TextAlign.Start, Lucide.TextAlignStart, stringResource(Res.string.announcements_format_align_start))
            AlignButton(state, TextAlign.Center, Lucide.TextAlignCenter, stringResource(Res.string.announcements_format_align_center))
            AlignButton(state, TextAlign.End, Lucide.TextAlignEnd, stringResource(Res.string.announcements_format_align_end))
            AlignButton(state, TextAlign.Justify, Lucide.TextAlignJustify, stringResource(Res.string.announcements_format_align_justify))
            RichToolbarDivider()
            RichToolbarButton(Lucide.RemoveFormatting, stringResource(Res.string.announcements_format_clear)) { clearFormatting(state) }
        }
    }

    if (linkDialog) {
        LinkDialog(
            onDismiss = {
                linkDialog = false
                linkSelection = null
            },
            onConfirm = { url ->
                val trimmed = url.trim()
                if (trimmed.isNotEmpty()) {
                    linkSelection?.let { state.selection = it }
                    runCatching {
                        if (state.selection.collapsed) {
                            state.addLink(text = trimmed, url = trimmed)
                        } else {
                            state.addLinkToSelection(trimmed)
                        }
                    }
                }
                linkDialog = false
                linkSelection = null
            },
        )
    }
}

@Composable
private fun HeadingButton(
    state: RichTextState,
    heading: HeadingStyle,
    icon: ImageVector,
    contentDescription: String,
) {
    val active = state.currentHeadingStyle == heading
    RichToolbarButton(icon, contentDescription, active = active) {
        state.setHeadingStyle(if (active) HeadingStyle.Normal else heading)
    }
}

@Composable
private fun AlignButton(
    state: RichTextState,
    align: TextAlign,
    icon: ImageVector,
    contentDescription: String,
) {
    val active = state.currentParagraphStyle.textAlign == align
    RichToolbarButton(icon, contentDescription, active = active) {
        state.toggleParagraphStyle(ParagraphStyle(textAlign = align))
    }
}

private fun clearFormatting(state: RichTextState) {
    runCatching {
        state.clearSpanStyles()
        state.setHeadingStyle(HeadingStyle.Normal)
        if (state.isUnorderedList) state.removeUnorderedList()
        if (state.isOrderedList) state.removeOrderedList()
    }
}

@Composable
private fun RichToolbarButton(
    icon: ImageVector,
    contentDescription: String,
    active: Boolean = false,
    enabled: Boolean = true,
    onClick: () -> Unit,
) {
    IconButton(
        onClick = onClick,
        enabled = enabled,
        modifier =
            Modifier
                .size(32.dp)
                .clip(AppShapes.small)
                .background(if (active) MaterialTheme.colorScheme.primaryContainer else Color.Transparent)
                .focusProperties { canFocus = false },
    ) {
        Icon(
            imageVector = icon,
            contentDescription = contentDescription,
            modifier = Modifier.size(18.dp),
            tint = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

@Composable
private fun RichToolbarDivider() {
    Spacer(
        modifier =
            Modifier
                .padding(horizontal = AppSpacing.space4, vertical = AppSpacing.space8)
                .width(1.dp)
                .height(20.dp)
                .background(MaterialTheme.colorScheme.outlineVariant),
    )
}

@Composable
private fun LinkDialog(
    onDismiss: () -> Unit,
    onConfirm: (String) -> Unit,
) {
    var url by remember { mutableStateOf("") }
    val focusRequester = remember { FocusRequester() }
    LaunchedEffect(Unit) { runCatching { focusRequester.requestFocus() } }
    AppModalCard(title = stringResource(Res.string.announcements_format_link), onDismiss = onDismiss) {
        OutlinedTextField(
            value = url,
            onValueChange = { url = it },
            label = { Text(stringResource(Res.string.announcements_link_url)) },
            modifier = Modifier.fillMaxWidth().focusRequester(focusRequester),
            singleLine = true,
        )
        Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End)) {
            AppButton(
                text = stringResource(Res.string.announcements_link_confirm),
                onClick = { onConfirm(url.trim()) },
                enabled = url.isNotBlank(),
            )
            AppButton(
                text = stringResource(Res.string.notifications_cancel),
                onClick = onDismiss,
                variant = PortalButtonVariant.Text,
            )
        }
    }
}

@Composable
private fun PriorityInfoButton(onClick: () -> Unit) {
    Box(
        modifier = Modifier.size(24.dp).clickable(onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            imageVector = Lucide.Info,
            contentDescription = stringResource(Res.string.notifications_field_priority),
            modifier = Modifier.size(18.dp),
            tint = MaterialTheme.colorScheme.primary,
        )
    }
}

@Composable
private fun PriorityInfoDialog(onDismiss: () -> Unit) {
    AppModalCard(title = stringResource(Res.string.announcements_priority_info_title), onDismiss = onDismiss) {
        Text(
            text = stringResource(Res.string.announcements_priority_info_hint),
            style = MaterialTheme.typography.bodyMedium,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
        PriorityInfoRow(NotificationPriority.LOW, stringResource(Res.string.announcements_priority_low_desc))
        PriorityInfoRow(NotificationPriority.MEDIUM, stringResource(Res.string.announcements_priority_medium_desc))
        PriorityInfoRow(NotificationPriority.HIGH, stringResource(Res.string.announcements_priority_high_desc))
    }
}

@Composable
private fun PriorityInfoRow(
    priority: NotificationPriority,
    description: String,
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space12),
        verticalAlignment = Alignment.Top,
    ) {
        Box(modifier = Modifier.width(72.dp), contentAlignment = Alignment.CenterStart) {
            PriorityChip(priority)
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
            Text(text = priorityLabel(priority), style = MaterialTheme.typography.titleSmall)
            Text(
                text = description,
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
        }
    }
}

private fun priorityColor(priority: NotificationPriority): Color =
    when (priority) {
        NotificationPriority.LOW -> AppPalette.Success500
        NotificationPriority.MEDIUM -> AppPalette.Warning500
        NotificationPriority.HIGH -> AppPalette.Error500
    }

@Composable
private fun priorityLabel(priority: NotificationPriority): String =
    stringResource(
        when (priority) {
            NotificationPriority.LOW -> Res.string.notifications_priority_low
            NotificationPriority.MEDIUM -> Res.string.notifications_priority_medium
            NotificationPriority.HIGH -> Res.string.notifications_priority_high
        },
    )

@Composable
private fun audienceLabel(audience: AnnouncementAudience): String =
    stringResource(
        when (audience) {
            AnnouncementAudience.ROLE -> Res.string.announcements_audience_role
            AnnouncementAudience.UNIT -> Res.string.announcements_audience_unit
            AnnouncementAudience.USER -> Res.string.announcements_audience_user
        },
    )
